import type { GetProfileByUsername200PreferencesTheme } from './getProfileByUsername200PreferencesTheme';

export type GetProfileByUsername200Preferences = {
  emailNotifications?: boolean;
  language?: string;
  theme?: GetProfileByUsername200PreferencesTheme;
};
